import React, { useEffect, useState } from "react";
import {
  FaSearch,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

import {
  getTMUsers,
  getSalesUsers,
} from "../../services/teamService";

import { getUsers } from "../../services/userService";

const TeamsManagerLayer = () => {
  const [activeTab, setActiveTab] = useState("tm");
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);

  /* =========================
     LOAD DATA
  ========================= */
  const loadData = async () => {
    try {
      setLoading(true);
      let res;

      if (activeTab === "tm") res = await getTMUsers();
      else if (activeTab === "sales") res = await getSalesUsers();
      else res = await getUsers();

      if (res?.status === "success") {
        setRows(res.data || []);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    loadData();
  }, [activeTab]);

  /* =========================
     ROLE LABEL
  ========================= */
  const getRoleLabel = (row) => {
    if (activeTab === "tm") return "Team Manager";
    if (activeTab === "sales") return "Sales Executive";

    if (row.role === "tm") return "Team Manager";
    if (row.role === "sales") return "Sales Executive";
    return "User";
  };

  /* =========================
     FILTER
  ========================= */
  const filteredRows = rows.filter((u) => {
    const matchSearch =
      `${u.name} ${u.email} ${u.mobile}`
        .toLowerCase()
        .includes(search.toLowerCase());

    const matchStatus =
      statusFilter === "all" || u.status === statusFilter;

    return matchSearch && matchStatus;
  });

  /* =========================
     PAGINATION
  ========================= */
  const totalPages =
    pageSize === "all"
      ? 1
      : Math.ceil(filteredRows.length / pageSize);

  const displayedRows =
    pageSize === "all"
      ? filteredRows
      : filteredRows.slice(
          (page - 1) * pageSize,
          page * pageSize
        );

  const getIndex = (i) =>
    pageSize === "all"
      ? i + 1
      : (page - 1) * pageSize + i + 1;

  /* =========================
     UI
  ========================= */
  return (
    <div className="user-list-wrapper">
      <div className="user-list-card">

        <div className="list-header">
          <h5>User Management</h5>
        </div>

        {/* TABS */}
        <div className="tab-buttons">
          <button
            className={activeTab === "tm" ? "active" : ""}
            onClick={() => setActiveTab("tm")}
          >
            Team Managers
          </button>
          <button
            className={activeTab === "sales" ? "active" : ""}
            onClick={() => setActiveTab("sales")}
          >
            Sales Executives
          </button>
          <button
            className={activeTab === "users" ? "active" : ""}
            onClick={() => setActiveTab("users")}
          >
            All Users
          </button>
        </div>

        {/* CONTROLS */}
        <div className="list-controls">
          <div className="search-box">
            <FaSearch />
            <input
              placeholder="Search name, email, mobile"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>

          <select
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>

          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(
                e.target.value === "all"
                  ? "all"
                  : Number(e.target.value)
              );
              setPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value="all">All</option>
          </select>
        </div>

        {/* TABLE */}
        {loading ? (
          <div className="no-data">Loading...</div>
        ) : displayedRows.length === 0 ? (
          <div className="no-data">No users found</div>
        ) : (
          <div className="table-responsive">
            <table className="user-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Role</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {displayedRows.map((u, i) => (
                  <tr key={u.id}>
                    <td>{getIndex(i)}</td>
                    <td>{getRoleLabel(u)}</td>
                    <td>{u.name}</td>
                    <td>{u.email}</td>
                    <td>{u.mobile}</td>
                    <td>
                      <span className={`status-badge ${u.status}`}>
                        {u.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* PAGINATION */}
        {pageSize !== "all" && totalPages > 1 && (
          <div className="pagination">
            <button disabled={page === 1} onClick={() => setPage(page - 1)}>
              <FaChevronLeft />
            </button>
            <span>
              Page {page} of {totalPages}
            </span>
            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              <FaChevronRight />
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default TeamsManagerLayer;
